export const STALE_TIME = {
  TEN_MINUTES: 10 * 60 * 1000,
  HOUR: 60 * 60 * 1000,
}